const fetch = (state = {}, action) => {
	switch (action.type) {
		case 'SET_LOADING':
			return { ...state, ...action.data };
		default:
			return state;
	}
};
export default fetch;
